/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkAddOrderStockPositionDto } from '../models/work-add-order-stock-position-dto';
import { WorkApplyAftercalcOrderDto } from '../models/work-apply-aftercalc-order-dto';
import { WorkCalculationitem } from '../models/work-calculationitem';
import { WorkOrder } from '../models/work-order';
import { WorkOrderSummaryLineDto } from '../models/work-order-summary-line-dto';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkUpdateOrderDto } from '../models/work-update-order-dto';

@Injectable({ providedIn: 'root' })
export class WorkOrdersV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `ordersV2ControllerFindAllPaginated()` */
  static readonly OrdersV2ControllerFindAllPaginatedPath = '/v2/orders';

  /**
   * Required permissions: orders:read, orders:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ordersV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  ordersV2ControllerFindAllPaginated$Response(
    params?: {

    /**
     * Filter by aftercalculated state (computed flag). `$eq:1` lists only fully aftercalculated orders, `$eq:0` only orders that still have a pending position.
     */
      'filter.isAftercalculated'?: Array<string>;

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 50
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 200
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by orderAt query param.
     *           <p>
     *              <b>Format: </b> filter.orderAt={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.orderAt=$not:$like:John Doe&filter.orderAt=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$gte</li>
     * <li>$lte</li>
     * <li>$btw</li>
     * <li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.orderAt'?: Array<string>;

    /**
     * Filter by deliverAt query param.
     *           <p>
     *              <b>Format: </b> filter.deliverAt={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.deliverAt=$not:$like:John Doe&filter.deliverAt=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$gte</li>
     * <li>$lte</li>
     * <li>$btw</li>
     * <li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.deliverAt'?: Array<string>;

    /**
     * Filter by deliveredAt query param.
     *           <p>
     *              <b>Format: </b> filter.deliveredAt={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.deliveredAt=$not:$like:John Doe&filter.deliveredAt=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$gte</li>
     * <li>$lte</li>
     * <li>$btw</li>
     * <li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.deliveredAt'?: Array<string>;

    /**
     * Filter by fullDelivery query param.
     *           <p>
     *              <b>Format: </b> filter.fullDelivery={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.fullDelivery=$not:$like:John Doe&filter.fullDelivery=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.fullDelivery'?: Array<string>;

    /**
     * Filter by deliverFix query param.
     *           <p>
     *              <b>Format: </b> filter.deliverFix={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.deliverFix=$not:$like:John Doe&filter.deliverFix=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.deliverFix'?: Array<string>;

    /**
     * Filter by orderBy query param.
     *           <p>
     *              <b>Format: </b> filter.orderBy={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.orderBy=$not:$like:John Doe&filter.orderBy=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li>
     * <li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.orderBy'?: Array<string>;

    /**
     * Filter by stocklocationId query param.
     *           <p>
     *              <b>Format: </b> filter.stocklocationId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.stocklocationId=$not:$like:John Doe&filter.stocklocationId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li>
     * <li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.stocklocationId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> orderAt:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>number</li>
     * <li>name</li>
     * <li>orderAt</li>
     * <li>deliverAt</li>
     * <li>deliveredAt</li>
     * <li>orderByContact.company</li>
     * <li>orderByContact.lastName</li>
     * <li>stocklocation.name</li>
     * <li>externalReference</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'number:ASC' | 'number:DESC' | 'name:ASC' | 'name:DESC' | 'orderAt:ASC' | 'orderAt:DESC' | 'deliverAt:ASC' | 'deliverAt:DESC' | 'deliveredAt:ASC' | 'deliveredAt:DESC' | 'orderByContact.company:ASC' | 'orderByContact.company:DESC' | 'orderByContact.lastName:ASC' | 'orderByContact.lastName:DESC' | 'stocklocation.name:ASC' | 'stocklocation.name:DESC' | 'externalReference:ASC' | 'externalReference:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name,number,externalReference,orderByContact.company,orderByContact.firstName
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li>
     * <li>number</li>
     * <li>externalReference</li>
     * <li>orderByContact.company</li>
     * <li>orderByContact.firstName</li>
     * <li>orderByContact.lastName</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkOrder>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'orderAt'?: (string | Array<string>);
'deliverAt'?: (string | Array<string>);
'deliveredAt'?: (string | Array<string>);
'fullDelivery'?: (string | Array<string>);
'deliverFix'?: (string | Array<string>);
'orderBy'?: (string | Array<string>);
'stocklocationId'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkOrdersV2Service.OrdersV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('filter.isAftercalculated', params['filter.isAftercalculated'], {});
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.orderAt', params['filter.orderAt'], {});
      rb.query('filter.deliverAt', params['filter.deliverAt'], {});
      rb.query('filter.deliveredAt', params['filter.deliveredAt'], {});
      rb.query('filter.fullDelivery', params['filter.fullDelivery'], {});
      rb.query('filter.deliverFix', params['filter.deliverFix'], {});
      rb.query('filter.orderBy', params['filter.orderBy'], {});
      rb.query('filter.stocklocationId', params['filter.stocklocationId'], {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkOrder>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'orderAt'?: (string | Array<string>);
        'deliverAt'?: (string | Array<string>);
        'deliveredAt'?: (string | Array<string>);
        'fullDelivery'?: (string | Array<string>);
        'deliverFix'?: (string | Array<string>);
        'orderBy'?: (string | Array<string>);
        'stocklocationId'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: orders:read, orders:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ordersV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ordersV2ControllerFindAllPaginated(
    params?: {

    /**
     * Filter by aftercalculated state (computed flag). `$eq:1` lists only fully aftercalculated orders, `$eq:0` only orders that still have a pending position.
     */
      'filter.isAftercalculated'?: Array<string>;

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 50
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 200
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by orderAt query param.
     *           <p>
     *              <b>Format: </b> filter.orderAt={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.orderAt=$not:$like:John Doe&filter.orderAt=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$gte</li>
     * <li>$lte</li>
     * <li>$btw</li>
     * <li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.orderAt'?: Array<string>;

    /**
     * Filter by deliverAt query param.
     *           <p>
     *              <b>Format: </b> filter.deliverAt={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.deliverAt=$not:$like:John Doe&filter.deliverAt=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$gte</li>
     * <li>$lte</li>
     * <li>$btw</li>
     * <li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.deliverAt'?: Array<string>;

    /**
     * Filter by deliveredAt query param.
     *           <p>
     *              <b>Format: </b> filter.deliveredAt={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.deliveredAt=$not:$like:John Doe&filter.deliveredAt=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$gte</li>
     * <li>$lte</li>
     * <li>$btw</li>
     * <li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.deliveredAt'?: Array<string>;

    /**
     * Filter by fullDelivery query param.
     *           <p>
     *              <b>Format: </b> filter.fullDelivery={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.fullDelivery=$not:$like:John Doe&filter.fullDelivery=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.fullDelivery'?: Array<string>;

    /**
     * Filter by deliverFix query param.
     *           <p>
     *              <b>Format: </b> filter.deliverFix={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.deliverFix=$not:$like:John Doe&filter.deliverFix=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.deliverFix'?: Array<string>;

    /**
     * Filter by orderBy query param.
     *           <p>
     *              <b>Format: </b> filter.orderBy={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.orderBy=$not:$like:John Doe&filter.orderBy=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li>
     * <li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.orderBy'?: Array<string>;

    /**
     * Filter by stocklocationId query param.
     *           <p>
     *              <b>Format: </b> filter.stocklocationId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.stocklocationId=$not:$like:John Doe&filter.stocklocationId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li>
     * <li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.stocklocationId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> orderAt:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>number</li>
     * <li>name</li>
     * <li>orderAt</li>
     * <li>deliverAt</li>
     * <li>deliveredAt</li>
     * <li>orderByContact.company</li>
     * <li>orderByContact.lastName</li>
     * <li>stocklocation.name</li>
     * <li>externalReference</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'number:ASC' | 'number:DESC' | 'name:ASC' | 'name:DESC' | 'orderAt:ASC' | 'orderAt:DESC' | 'deliverAt:ASC' | 'deliverAt:DESC' | 'deliveredAt:ASC' | 'deliveredAt:DESC' | 'orderByContact.company:ASC' | 'orderByContact.company:DESC' | 'orderByContact.lastName:ASC' | 'orderByContact.lastName:DESC' | 'stocklocation.name:ASC' | 'stocklocation.name:DESC' | 'externalReference:ASC' | 'externalReference:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name,number,externalReference,orderByContact.company,orderByContact.firstName
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li>
     * <li>number</li>
     * <li>externalReference</li>
     * <li>orderByContact.company</li>
     * <li>orderByContact.firstName</li>
     * <li>orderByContact.lastName</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkOrder>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'orderAt'?: (string | Array<string>);
'deliverAt'?: (string | Array<string>);
'deliveredAt'?: (string | Array<string>);
'fullDelivery'?: (string | Array<string>);
'deliverFix'?: (string | Array<string>);
'orderBy'?: (string | Array<string>);
'stocklocationId'?: (string | Array<string>);
};
};
}> {
    return this.ordersV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkOrder>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'orderAt'?: (string | Array<string>);
'deliverAt'?: (string | Array<string>);
'deliveredAt'?: (string | Array<string>);
'fullDelivery'?: (string | Array<string>);
'deliverFix'?: (string | Array<string>);
'orderBy'?: (string | Array<string>);
'stocklocationId'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkOrder>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'orderAt'?: (string | Array<string>);
'deliverAt'?: (string | Array<string>);
'deliveredAt'?: (string | Array<string>);
'fullDelivery'?: (string | Array<string>);
'deliverFix'?: (string | Array<string>);
'orderBy'?: (string | Array<string>);
'stocklocationId'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `ordersV2ControllerFindOneById()` */
  static readonly OrdersV2ControllerFindOneByIdPath = '/v2/orders/{id}';

  /**
   * Required permissions: orders:read, orders:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ordersV2ControllerFindOneById()` instead.
   *
   * This method doesn't expect any request body.
   */
  ordersV2ControllerFindOneById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkOrder>> {
    const rb = new RequestBuilder(this.rootUrl, WorkOrdersV2Service.OrdersV2ControllerFindOneByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkOrder>;
      })
    );
  }

  /**
   * Required permissions: orders:read, orders:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ordersV2ControllerFindOneById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ordersV2ControllerFindOneById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkOrder> {
    return this.ordersV2ControllerFindOneById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkOrder>): WorkOrder => r.body)
    );
  }

  /** Path part for operation `ordersV2ControllerUpdate()` */
  static readonly OrdersV2ControllerUpdatePath = '/v2/orders/{id}';

  /**
   * Required permissions: orders:update, orders:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ordersV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ordersV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateOrderDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkOrder>> {
    const rb = new RequestBuilder(this.rootUrl, WorkOrdersV2Service.OrdersV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkOrder>;
      })
    );
  }

  /**
   * Required permissions: orders:update, orders:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ordersV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ordersV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateOrderDto
    },
    context?: HttpContext
  ): Observable<WorkOrder> {
    return this.ordersV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkOrder>): WorkOrder => r.body)
    );
  }

  /** Path part for operation `ordersV2ControllerFindSummaryByOrderId()` */
  static readonly OrdersV2ControllerFindSummaryByOrderIdPath = '/v2/orders/{id}/summary';

  /**
   * Required permissions: orders:read, orders:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ordersV2ControllerFindSummaryByOrderId()` instead.
   *
   * This method doesn't expect any request body.
   */
  ordersV2ControllerFindSummaryByOrderId$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkOrderSummaryLineDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkOrdersV2Service.OrdersV2ControllerFindSummaryByOrderIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkOrderSummaryLineDto>>;
      })
    );
  }

  /**
   * Required permissions: orders:read, orders:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ordersV2ControllerFindSummaryByOrderId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ordersV2ControllerFindSummaryByOrderId(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkOrderSummaryLineDto>> {
    return this.ordersV2ControllerFindSummaryByOrderId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkOrderSummaryLineDto>>): Array<WorkOrderSummaryLineDto> => r.body)
    );
  }

  /** Path part for operation `ordersV2ControllerFindCalculationitemsByOrderId()` */
  static readonly OrdersV2ControllerFindCalculationitemsByOrderIdPath = '/v2/orders/{id}/calculationitems';

  /**
   * Required permissions: orders:read, orders:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ordersV2ControllerFindCalculationitemsByOrderId()` instead.
   *
   * This method doesn't expect any request body.
   */
  ordersV2ControllerFindCalculationitemsByOrderId$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkCalculationitem>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkOrdersV2Service.OrdersV2ControllerFindCalculationitemsByOrderIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkCalculationitem>>;
      })
    );
  }

  /**
   * Required permissions: orders:read, orders:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ordersV2ControllerFindCalculationitemsByOrderId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ordersV2ControllerFindCalculationitemsByOrderId(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkCalculationitem>> {
    return this.ordersV2ControllerFindCalculationitemsByOrderId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkCalculationitem>>): Array<WorkCalculationitem> => r.body)
    );
  }

  /** Path part for operation `ordersV2ControllerApplyAftercalc()` */
  static readonly OrdersV2ControllerApplyAftercalcPath = '/v2/orders/{id}/aftercalc';

  /**
   * Required permissions: orders:update, orders:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ordersV2ControllerApplyAftercalc()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ordersV2ControllerApplyAftercalc$Response(
    params: {
      id: number;
      body: WorkApplyAftercalcOrderDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkCalculationitem>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkOrdersV2Service.OrdersV2ControllerApplyAftercalcPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkCalculationitem>>;
      })
    );
  }

  /**
   * Required permissions: orders:update, orders:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ordersV2ControllerApplyAftercalc$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ordersV2ControllerApplyAftercalc(
    params: {
      id: number;
      body: WorkApplyAftercalcOrderDto
    },
    context?: HttpContext
  ): Observable<Array<WorkCalculationitem>> {
    return this.ordersV2ControllerApplyAftercalc$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkCalculationitem>>): Array<WorkCalculationitem> => r.body)
    );
  }

  /** Path part for operation `ordersV2ControllerResetAftercalc()` */
  static readonly OrdersV2ControllerResetAftercalcPath = '/v2/orders/{id}/reset-aftercalc';

  /**
   * Required permissions: orders:update, orders:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ordersV2ControllerResetAftercalc()` instead.
   *
   * This method doesn't expect any request body.
   */
  ordersV2ControllerResetAftercalc$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkOrdersV2Service.OrdersV2ControllerResetAftercalcPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: orders:update, orders:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ordersV2ControllerResetAftercalc$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ordersV2ControllerResetAftercalc(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.ordersV2ControllerResetAftercalc$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `ordersV2ControllerAddStockPosition()` */
  static readonly OrdersV2ControllerAddStockPositionPath = '/v2/orders/{id}/stock-position';

  /**
   * Required permissions: orders:update, orders:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ordersV2ControllerAddStockPosition()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ordersV2ControllerAddStockPosition$Response(
    params: {
      id: number;
      body: WorkAddOrderStockPositionDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkCalculationitem>> {
    const rb = new RequestBuilder(this.rootUrl, WorkOrdersV2Service.OrdersV2ControllerAddStockPositionPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkCalculationitem>;
      })
    );
  }

  /**
   * Required permissions: orders:update, orders:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ordersV2ControllerAddStockPosition$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ordersV2ControllerAddStockPosition(
    params: {
      id: number;
      body: WorkAddOrderStockPositionDto
    },
    context?: HttpContext
  ): Observable<WorkCalculationitem> {
    return this.ordersV2ControllerAddStockPosition$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkCalculationitem>): WorkCalculationitem => r.body)
    );
  }

}
